// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Alexforbes / Ant Design customization */
:root {
  --primary-color: #007A7A;
  --primary-hover: #00A3A3;
  --primary-active: #005C5C;
  --accent-orange: #FF6600;
  --accent-orange-hover: #FF8533;
  --accent-orange-active: #CC5200;
  --btn-primary-color: #FF6600;
  --btn-primary-hover: #FF8533;
  --btn-primary-active: #CC5200;
  --header-bg-color: #007A7A;
  --sidebar-bg-color: #003D3D;
  --af-background: #F4F6F8;
}

/* Logo container (sidebar) — transparent SVG on light panel */
.logo {
  min-height: 48px;
  margin: 16px 12px;
  padding: 8px 10px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo .af-brand-logo {
  width: 100%;
  max-width: 100%;
  height: 32px;
}

.ant-layout-sider-collapsed .logo {
  padding: 8px;
}

.ant-layout-sider-collapsed .logo .af-brand-logo {
  height: 28px;
}

.af-brand-logo--header {
  max-height: 40px;
}

.af-report-brand-header {
  border-bottom: 2px solid var(--primary-color, #007a7a);
}

/* Layout adjustments */
.ant-layout {
  background: var(--af-background, #f4f6f8);
  overflow: hidden;
}

.ant-layout-sider {
  box-shadow: 2px 0 8px 0 rgba(29, 35, 41, 0.05);
  overflow: hidden;
}

.ant-layout-sider-dark {
  background: #001529;
}

.ant-layout-sider-light {
  background: #fff;
}

/* Menu customization */
.ant-menu {
  border-right: none;
}

.ant-menu-item {
  margin: 4px 0 !important;
}

.ant-menu-dark .ant-menu-item-selected,
.ant-menu-item-selected {
  background-color: var(--primary-active) !important;
}

.ant-menu-dark .ant-menu-item:hover,
.ant-menu-item:hover {
  background-color: var(--primary-hover) !important;
}

.ant-btn-primary:not(:disabled) {
  background-color: var(--btn-primary-color) !important;
  border-color: var(--btn-primary-color) !important;
}

.ant-btn-primary:not(:disabled):hover {
  background-color: var(--btn-primary-hover) !important;
  border-color: var(--btn-primary-hover) !important;
}

.ant-btn-primary:not(:disabled):active {
  background-color: var(--btn-primary-active) !important;
  border-color: var(--btn-primary-active) !important;
}

/* Custom tag colors (hex from brand palette) */
.ant-tag.af-tag-orange {
  color: #fff !important;
  background: var(--accent-orange) !important;
  border-color: var(--accent-orange) !important;
}

.ant-tag.af-tag-teal {
  color: #fff !important;
  background: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
}

.ant-btn-link {
  color: var(--primary-color) !important;
}

.ant-btn-link:not(:disabled):hover {
  color: var(--primary-hover) !important;
}

.ant-tabs .ant-tabs-ink-bar {
  background: var(--btn-primary-color) !important;
}

.ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: var(--btn-primary-color) !important;
}

/* Header customization */
.ant-layout-header {
  background: #fff;
  padding: 0;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
}

/* Content area */
.ant-layout-content {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
}

.app-main-content-scroll {
  flex: 1 1;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

/* Dark mode adjustments */
.ant-layout-sider-dark .logo {
  background: rgba(255, 255, 255, 0.1);
}

.ant-layout-sider-dark .ant-menu {
  background: transparent;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .ant-layout-sider {
    position: fixed;
    z-index: 1000;
  }
  
  .ant-layout {
    margin-left: 0 !important;
  }
}

/* Ensure only table content scrolls */
html, body {
  overflow: hidden;
  height: 100%;
  margin: 0;
  padding: 0;
}

/* Full-height table pages (trades, instruments) */
.app-table-page {
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.app-table-page > .ant-card {
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex: 1 1;
}

.app-table-page > .ant-card > .ant-card-body {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 24px;
}

/* Table styles with fixed headers */
.ant-table-wrapper {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  overflow: visible;
  min-height: 0;
}

.ant-table {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.ant-table-container {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.ant-table-wrapper .ant-table-thead > tr > th {
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: var(--header-bg-color, #007a7a) !important;
  color: white !important;
}

/* Ensure table scrolls properly */
.ant-table-body {
  overflow: auto !important;
  flex: 1 1;
  max-height: calc(100vh - 400px) !important; /* Limit max height to ensure pagination is visible */
}

/* Ensure table headers don't scroll horizontally with content */
.ant-table-header {
  overflow: hidden !important;
}

/* Pagination styles */
.ant-table-pagination {
  margin: 16px 0 !important;
  position: static !important;
  background-color: inherit !important;
  z-index: auto !important;
  padding: 8px 0 !important;
  border-top: 1px solid #f0f0f0 !important;
}

[data-theme="dark"] .ant-table-pagination {
  border-top-color: #303030 !important;
}

/* Pagination in dark mode */
[data-theme="dark"] .ant-pagination {
  background-color: #1f1f1f;
  color: white;
}

/* Fix for horizontal scrolling */
.ant-table-body {
  overflow-x: auto !important;
  overflow-y: auto !important;
}

/* Resizable columns */
.react-resizable {
  position: relative;
  background-clip: padding-box;
}

.react-resizable-handle {
  position: absolute;
  right: -5px;
  bottom: 0;
  z-index: 1;
  width: 10px;
  height: 100%;
  cursor: col-resize;
}

.react-resizable-handle:hover {
  background-color: rgba(0, 122, 122, 0.25);
}

.react-resizable-handle:active {
  background-color: rgba(0, 92, 92, 0.4);
}

/* Fix for table header alignment with resizable columns */
.ant-table-thead > tr > th {
  position: relative;
} 

/* Sidebar logout button */
.sidebar-logout-btn.ant-btn {
  color: #fff !important;
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
}

.sidebar-logout-btn.ant-btn.ant-btn-text:not(:disabled):hover,
.sidebar-logout-btn.ant-btn.ant-btn-text:not(:disabled):focus-visible {
  color: #fff !important;
  background-color: rgba(255, 255, 255, 0.14) !important;
  border-color: rgba(255, 255, 255, 0.4) !important;
}

.sidebar-logout-btn.ant-btn.ant-btn-text:not(:disabled):active {
  color: #fff !important;
  background-color: rgba(255, 255, 255, 0.2) !important;
  border-color: rgba(255, 255, 255, 0.45) !important;
}
.af-markdown-preview,
.af-performance-report-preview {
  font-size: 14px;
  line-height: 1.65;
  color: #1a1a1a;
}

.af-markdown-preview > :first-child,
.af-performance-report-preview > :first-child {
  margin-top: 0;
}

.af-markdown-preview p,
.af-performance-report-preview p {
  margin: 0.65em 0;
}

.af-markdown-preview h1,
.af-performance-report-preview h1 {
  font-size: 1.5rem;
  color: #007a7a;
  margin: 1.25rem 0 0.5rem;
  font-weight: 600;
}

.af-markdown-preview h2,
.af-performance-report-preview h2 {
  font-size: 1.15rem;
  color: #333;
  margin: 1rem 0 0.4rem;
  font-weight: 600;
}

.af-markdown-preview h3,
.af-performance-report-preview h3 {
  font-size: 1rem;
  color: #4d4d4d;
  margin: 0.85rem 0 0.35rem;
  font-weight: 600;
}

.af-markdown-preview ul,
.af-markdown-preview ol,
.af-performance-report-preview ul,
.af-performance-report-preview ol {
  margin: 0.5em 0;
  padding-left: 1.5em;
}

.af-markdown-preview li,
.af-performance-report-preview li {
  margin: 0.25em 0;
}

.af-markdown-preview strong,
.af-performance-report-preview strong {
  font-weight: 600;
}

.af-markdown-preview blockquote,
.af-performance-report-preview blockquote {
  margin: 0.75em 0;
  padding: 8px 16px;
  border-left: 4px solid var(--accent-orange, #ff6600);
  background: #fafafa;
  color: #4d4d4d;
}

.af-markdown-preview table,
.af-performance-report-preview table {
  width: 100%;
  border-collapse: collapse;
  margin: 12px 0;
}

.af-markdown-preview th,
.af-markdown-preview td,
.af-performance-report-preview th,
.af-performance-report-preview td {
  border: 1px solid #e8e8e8;
  padding: 8px 12px;
  text-align: left;
}

.af-markdown-preview th,
.af-performance-report-preview th {
  background: #f5f5f5;
}

/* Dark mode — readable secondary / markdown text */
[data-theme="dark"] .ant-typography.ant-typography-secondary,
[data-theme="dark"] .ant-statistic-title,
[data-theme="dark"] .ant-descriptions-item-label {
  color: rgba(240, 242, 245, 0.65) !important;
}

[data-theme="dark"] .af-markdown-preview,
[data-theme="dark"] .af-performance-report-preview {
  color: #e8eaed;
  background: #1a2226;
}

[data-theme="dark"] .af-markdown-preview h1,
[data-theme="dark"] .af-performance-report-preview h1 {
  color: #3dbdbd;
}

[data-theme="dark"] .af-markdown-preview h2,
[data-theme="dark"] .af-performance-report-preview h2,
[data-theme="dark"] .af-markdown-preview h3,
[data-theme="dark"] .af-performance-report-preview h3 {
  color: #f0f2f5;
}

[data-theme="dark"] .af-markdown-preview blockquote,
[data-theme="dark"] .af-performance-report-preview blockquote {
  background: #12181c;
  color: rgba(240, 242, 245, 0.75);
}

[data-theme="dark"] .af-markdown-preview th,
[data-theme="dark"] .af-markdown-preview td,
[data-theme="dark"] .af-performance-report-preview th,
[data-theme="dark"] .af-performance-report-preview td {
  border-color: #30363d;
}

[data-theme="dark"] .af-markdown-preview th,
[data-theme="dark"] .af-performance-report-preview th {
  background: #12181c;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;EACE,wBAAwB;EACxB,wBAAwB;EACxB,yBAAyB;EACzB,wBAAwB;EACxB,8BAA8B;EAC9B,+BAA+B;EAC/B,4BAA4B;EAC5B,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA,8DAA8D;AAC9D;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sDAAsD;AACxD;;AAEA,uBAAuB;AACvB;EACE,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,kDAAkD;AACpD;;AAEA;;EAEE,iDAAiD;AACnD;;AAEA;EACE,qDAAqD;EACrD,iDAAiD;AACnD;;AAEA;EACE,qDAAqD;EACrD,iDAAiD;AACnD;;AAEA;EACE,sDAAsD;EACtD,kDAAkD;AACpD;;AAEA,+CAA+C;AAC/C;EACE,sBAAsB;EACtB,2CAA2C;EAC3C,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;EACtB,2CAA2C;EAC3C,6CAA6C;AAC/C;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,UAAU;EACV,2CAA2C;AAC7C;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,SAAO;EACP,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA,0BAA0B;AAC1B;EACE,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;AACzB;;AAEA,2BAA2B;AAC3B;EACE;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,sCAAsC;AACtC;EACE,gBAAgB;EAChB,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;;AAEA,kDAAkD;AAClD;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;AACf;;AAEA,oCAAoC;AACpC;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,4DAA4D;EAC5D,uBAAuB;AACzB;;AAEA,kCAAkC;AAClC;EACE,yBAAyB;EACzB,SAAO;EACP,0CAA0C,EAAE,qDAAqD;AACnG;;AAEA,gEAAgE;AAChE;EACE,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,oCAAoC;EACpC,wBAAwB;EACxB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;AACtC;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,iCAAiC;AACjC;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,sCAAsC;AACxC;;AAEA,0DAA0D;AAC1D;EACE,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,sBAAsB;EACtB,sDAAsD;AACxD;;AAEA;;EAEE,sBAAsB;EACtB,sDAAsD;EACtD,iDAAiD;AACnD;;AAEA;EACE,sBAAsB;EACtB,qDAAqD;EACrD,kDAAkD;AACpD;AACA;;EAEE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,cAAc;EACd,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;;;EAIE,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,oDAAoD;EACpD,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;;;EAIE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA,mDAAmD;AACnD;;;EAGE,2CAA2C;AAC7C;;AAEA;;EAEE,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;AACrB","sourcesContent":["/* Alexforbes / Ant Design customization */\n:root {\n  --primary-color: #007A7A;\n  --primary-hover: #00A3A3;\n  --primary-active: #005C5C;\n  --accent-orange: #FF6600;\n  --accent-orange-hover: #FF8533;\n  --accent-orange-active: #CC5200;\n  --btn-primary-color: #FF6600;\n  --btn-primary-hover: #FF8533;\n  --btn-primary-active: #CC5200;\n  --header-bg-color: #007A7A;\n  --sidebar-bg-color: #003D3D;\n  --af-background: #F4F6F8;\n}\n\n/* Logo container (sidebar) — transparent SVG on light panel */\n.logo {\n  min-height: 48px;\n  margin: 16px 12px;\n  padding: 8px 10px;\n  background: rgba(255, 255, 255, 0.95);\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.logo .af-brand-logo {\n  width: 100%;\n  max-width: 100%;\n  height: 32px;\n}\n\n.ant-layout-sider-collapsed .logo {\n  padding: 8px;\n}\n\n.ant-layout-sider-collapsed .logo .af-brand-logo {\n  height: 28px;\n}\n\n.af-brand-logo--header {\n  max-height: 40px;\n}\n\n.af-report-brand-header {\n  border-bottom: 2px solid var(--primary-color, #007a7a);\n}\n\n/* Layout adjustments */\n.ant-layout {\n  background: var(--af-background, #f4f6f8);\n  overflow: hidden;\n}\n\n.ant-layout-sider {\n  box-shadow: 2px 0 8px 0 rgba(29, 35, 41, 0.05);\n  overflow: hidden;\n}\n\n.ant-layout-sider-dark {\n  background: #001529;\n}\n\n.ant-layout-sider-light {\n  background: #fff;\n}\n\n/* Menu customization */\n.ant-menu {\n  border-right: none;\n}\n\n.ant-menu-item {\n  margin: 4px 0 !important;\n}\n\n.ant-menu-dark .ant-menu-item-selected,\n.ant-menu-item-selected {\n  background-color: var(--primary-active) !important;\n}\n\n.ant-menu-dark .ant-menu-item:hover,\n.ant-menu-item:hover {\n  background-color: var(--primary-hover) !important;\n}\n\n.ant-btn-primary:not(:disabled) {\n  background-color: var(--btn-primary-color) !important;\n  border-color: var(--btn-primary-color) !important;\n}\n\n.ant-btn-primary:not(:disabled):hover {\n  background-color: var(--btn-primary-hover) !important;\n  border-color: var(--btn-primary-hover) !important;\n}\n\n.ant-btn-primary:not(:disabled):active {\n  background-color: var(--btn-primary-active) !important;\n  border-color: var(--btn-primary-active) !important;\n}\n\n/* Custom tag colors (hex from brand palette) */\n.ant-tag.af-tag-orange {\n  color: #fff !important;\n  background: var(--accent-orange) !important;\n  border-color: var(--accent-orange) !important;\n}\n\n.ant-tag.af-tag-teal {\n  color: #fff !important;\n  background: var(--primary-color) !important;\n  border-color: var(--primary-color) !important;\n}\n\n.ant-btn-link {\n  color: var(--primary-color) !important;\n}\n\n.ant-btn-link:not(:disabled):hover {\n  color: var(--primary-hover) !important;\n}\n\n.ant-tabs .ant-tabs-ink-bar {\n  background: var(--btn-primary-color) !important;\n}\n\n.ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n  color: var(--btn-primary-color) !important;\n}\n\n/* Header customization */\n.ant-layout-header {\n  background: #fff;\n  padding: 0;\n  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);\n}\n\n/* Content area */\n.ant-layout-content {\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);\n}\n\n.app-main-content-scroll {\n  flex: 1;\n  min-height: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n/* Dark mode adjustments */\n.ant-layout-sider-dark .logo {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.ant-layout-sider-dark .ant-menu {\n  background: transparent;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .ant-layout-sider {\n    position: fixed;\n    z-index: 1000;\n  }\n  \n  .ant-layout {\n    margin-left: 0 !important;\n  }\n}\n\n/* Ensure only table content scrolls */\nhtml, body {\n  overflow: hidden;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n}\n\n/* Full-height table pages (trades, instruments) */\n.app-table-page {\n  height: 100%;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.app-table-page > .ant-card {\n  height: 100%;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  flex: 1;\n}\n\n.app-table-page > .ant-card > .ant-card-body {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  padding: 24px;\n}\n\n/* Table styles with fixed headers */\n.ant-table-wrapper {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: visible;\n  min-height: 0;\n}\n\n.ant-table {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.ant-table-container {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.ant-table-wrapper .ant-table-thead > tr > th {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  background-color: var(--header-bg-color, #007a7a) !important;\n  color: white !important;\n}\n\n/* Ensure table scrolls properly */\n.ant-table-body {\n  overflow: auto !important;\n  flex: 1;\n  max-height: calc(100vh - 400px) !important; /* Limit max height to ensure pagination is visible */\n}\n\n/* Ensure table headers don't scroll horizontally with content */\n.ant-table-header {\n  overflow: hidden !important;\n}\n\n/* Pagination styles */\n.ant-table-pagination {\n  margin: 16px 0 !important;\n  position: static !important;\n  background-color: inherit !important;\n  z-index: auto !important;\n  padding: 8px 0 !important;\n  border-top: 1px solid #f0f0f0 !important;\n}\n\n[data-theme=\"dark\"] .ant-table-pagination {\n  border-top-color: #303030 !important;\n}\n\n/* Pagination in dark mode */\n[data-theme=\"dark\"] .ant-pagination {\n  background-color: #1f1f1f;\n  color: white;\n}\n\n/* Fix for horizontal scrolling */\n.ant-table-body {\n  overflow-x: auto !important;\n  overflow-y: auto !important;\n}\n\n/* Resizable columns */\n.react-resizable {\n  position: relative;\n  background-clip: padding-box;\n}\n\n.react-resizable-handle {\n  position: absolute;\n  right: -5px;\n  bottom: 0;\n  z-index: 1;\n  width: 10px;\n  height: 100%;\n  cursor: col-resize;\n}\n\n.react-resizable-handle:hover {\n  background-color: rgba(0, 122, 122, 0.25);\n}\n\n.react-resizable-handle:active {\n  background-color: rgba(0, 92, 92, 0.4);\n}\n\n/* Fix for table header alignment with resizable columns */\n.ant-table-thead > tr > th {\n  position: relative;\n} \n\n/* Sidebar logout button */\n.sidebar-logout-btn.ant-btn {\n  color: #fff !important;\n  border: 1px solid rgba(255, 255, 255, 0.25) !important;\n}\n\n.sidebar-logout-btn.ant-btn.ant-btn-text:not(:disabled):hover,\n.sidebar-logout-btn.ant-btn.ant-btn-text:not(:disabled):focus-visible {\n  color: #fff !important;\n  background-color: rgba(255, 255, 255, 0.14) !important;\n  border-color: rgba(255, 255, 255, 0.4) !important;\n}\n\n.sidebar-logout-btn.ant-btn.ant-btn-text:not(:disabled):active {\n  color: #fff !important;\n  background-color: rgba(255, 255, 255, 0.2) !important;\n  border-color: rgba(255, 255, 255, 0.45) !important;\n}\n.af-markdown-preview,\n.af-performance-report-preview {\n  font-size: 14px;\n  line-height: 1.65;\n  color: #1a1a1a;\n}\n\n.af-markdown-preview > :first-child,\n.af-performance-report-preview > :first-child {\n  margin-top: 0;\n}\n\n.af-markdown-preview p,\n.af-performance-report-preview p {\n  margin: 0.65em 0;\n}\n\n.af-markdown-preview h1,\n.af-performance-report-preview h1 {\n  font-size: 1.5rem;\n  color: #007a7a;\n  margin: 1.25rem 0 0.5rem;\n  font-weight: 600;\n}\n\n.af-markdown-preview h2,\n.af-performance-report-preview h2 {\n  font-size: 1.15rem;\n  color: #333;\n  margin: 1rem 0 0.4rem;\n  font-weight: 600;\n}\n\n.af-markdown-preview h3,\n.af-performance-report-preview h3 {\n  font-size: 1rem;\n  color: #4d4d4d;\n  margin: 0.85rem 0 0.35rem;\n  font-weight: 600;\n}\n\n.af-markdown-preview ul,\n.af-markdown-preview ol,\n.af-performance-report-preview ul,\n.af-performance-report-preview ol {\n  margin: 0.5em 0;\n  padding-left: 1.5em;\n}\n\n.af-markdown-preview li,\n.af-performance-report-preview li {\n  margin: 0.25em 0;\n}\n\n.af-markdown-preview strong,\n.af-performance-report-preview strong {\n  font-weight: 600;\n}\n\n.af-markdown-preview blockquote,\n.af-performance-report-preview blockquote {\n  margin: 0.75em 0;\n  padding: 8px 16px;\n  border-left: 4px solid var(--accent-orange, #ff6600);\n  background: #fafafa;\n  color: #4d4d4d;\n}\n\n.af-markdown-preview table,\n.af-performance-report-preview table {\n  width: 100%;\n  border-collapse: collapse;\n  margin: 12px 0;\n}\n\n.af-markdown-preview th,\n.af-markdown-preview td,\n.af-performance-report-preview th,\n.af-performance-report-preview td {\n  border: 1px solid #e8e8e8;\n  padding: 8px 12px;\n  text-align: left;\n}\n\n.af-markdown-preview th,\n.af-performance-report-preview th {\n  background: #f5f5f5;\n}\n\n/* Dark mode — readable secondary / markdown text */\n[data-theme=\"dark\"] .ant-typography.ant-typography-secondary,\n[data-theme=\"dark\"] .ant-statistic-title,\n[data-theme=\"dark\"] .ant-descriptions-item-label {\n  color: rgba(240, 242, 245, 0.65) !important;\n}\n\n[data-theme=\"dark\"] .af-markdown-preview,\n[data-theme=\"dark\"] .af-performance-report-preview {\n  color: #e8eaed;\n  background: #1a2226;\n}\n\n[data-theme=\"dark\"] .af-markdown-preview h1,\n[data-theme=\"dark\"] .af-performance-report-preview h1 {\n  color: #3dbdbd;\n}\n\n[data-theme=\"dark\"] .af-markdown-preview h2,\n[data-theme=\"dark\"] .af-performance-report-preview h2,\n[data-theme=\"dark\"] .af-markdown-preview h3,\n[data-theme=\"dark\"] .af-performance-report-preview h3 {\n  color: #f0f2f5;\n}\n\n[data-theme=\"dark\"] .af-markdown-preview blockquote,\n[data-theme=\"dark\"] .af-performance-report-preview blockquote {\n  background: #12181c;\n  color: rgba(240, 242, 245, 0.75);\n}\n\n[data-theme=\"dark\"] .af-markdown-preview th,\n[data-theme=\"dark\"] .af-markdown-preview td,\n[data-theme=\"dark\"] .af-performance-report-preview th,\n[data-theme=\"dark\"] .af-performance-report-preview td {\n  border-color: #30363d;\n}\n\n[data-theme=\"dark\"] .af-markdown-preview th,\n[data-theme=\"dark\"] .af-performance-report-preview th {\n  background: #12181c;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
